import { EventEmitter } from 'events';

export default class Dispatcher extends EventEmitter {

	constructor() {
		super();
		this._stores = {};
		this.service = false;
	}

	dispatch(name, payload) {
		this.emit(name, payload);
	}

	registerStore(Store) {
		var name = Store.storeName, action, handler;
		if(this._stores[name]) {
			return;
		}
		this._stores[name] = new Store(this);
		if(Store.handlers){
			for(action in Store.handlers) {
				handler = this._stores[name][Store.handlers[action]];
				if(handler) {
					this.on(action, handler.bind(this._stores[name]));
				}
			}
		}
	}

	getStore(name) {
		return this._stores[name.storeName];
	}

	setService(service) {
		this.service = service;
	}

	setHistory(history) {
		this.history = history;
	}

	rehydrate(state) {
		var name;
		for(name in state) {
			if(this._stores[name]) {
			this._stores[name].rehydrate(state[name]);
			}
		}
	}

	dehydrate() {
		var state = {};
		var name;
		for(name in this._stores) {
			state[name] = this._stores[name].dehydrate();
		}
		return state;
	}



	executeAction(action, payload) {
		var len = action.length, promise;
		payload = payload || {};



		if(len == 3) {
			promise =  new Promise((resolve, reject) => {
				action(this, payload, function(err, data){
					if(err) {
						reject(err);
					} else {
						resolve(data);
					}
				});
			});

		} else {
			promise = Promise.resolve(action(this, payload));
		}

		promise.catch(function(err){
			console.log(err);
		});

		return promise;
	}

}
